import {
    GET_CURRENT_INTERFACE
} from './constants';

const initialState = {
    currentInterface: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_INTERFACE: {
            return {
                ...state,
                currentInterface: action.payload,
            };
        }
        default:
            return state;
    }
};

